import React, { useRef } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../context/StoreProvider';

export default function TransLang() {
    const store = useStore();
    const { i18n } = useTranslation();
    const switchingRef = useRef(false);

    // Source of truth for the label: active i18n language
    const lng = (i18n.resolvedLanguage || i18n.language || 'ar').startsWith('en')
        ? 'en'
        : 'ar';

    const toggleLanguage = async () => {
        if (switchingRef.current || !store?.changeLanguage) return;

        const otherLng = lng === 'en' ? 'ar' : 'en';

        try {
            switchingRef.current = true;
            await store.changeLanguage(otherLng);
        } finally {
            switchingRef.current = false;
        }
    };

    return (
        <Typography
            onClick={toggleLanguage}
            color={'primary.text'}
            fontWeight={'bold'}
            variant="h6"
            sx={{ fontSize: '1.2rem', cursor: 'pointer' }}
        >
            {lng === 'en' ? 'AR' : 'EN'}
        </Typography>
    );
}
